export const INIT_USER_INFO = ' INIT_USER_INFO'
export const SET_LOGIN_STATE = ' SET_LOGIN_STATE'
export const INIT_GETLETTERLIST = ' INIT_GETLETTERLIST'
export const INIT_SENDLETTERLIST = ' INIT_SENDLETTERLIST'
export const INIT_ACCOUNTRECORDLIST = ' INIT_ACCOUNTRECORDLIST'
export const INIT_COMPLAINLIST = ' INIT_COMPLAINLIST'
export const INIT_HELPLIST = ' INIT_HELPLIST'
export const INIT_SIGNDATA = ' INIT_SIGNDATA'
export const INIT_GAMEDATALIST = ' INIT_GAMEDATALIST'
export const INIT_GAMEMAPDATALIST = ' INIT_GAMEMAPDATALIST'



// WEBPACK FOOTER //
// ./src/logic/user/mutation-types.js